import { useEffect, useState } from "react";
import { DateTime } from "luxon";
// FIXME: We are not importing via `~utils` due to a circular dependency
import { translate } from "utils/string-table";

export const NOTIFY_CHOICES = [24, 12, 6, 2];
const DEFAULT_NOTIFY_CHOICE = NOTIFY_CHOICES.at(-1) || 2;
export const ONLY_SELECTED_SUBS_CHOICE = translate("TIME_TO_ACCEPT_ONLY_SELECTED_SUBS_VALUE");

export const getTimeToAcceptChoices = (
  reqDate: DateTime,
  now: DateTime = DateTime.now(),
): (number | string)[] => {
  // If the request starts in less than 2 hours, only show "Only selected subs"
  if (reqDate.diff(now, "hours").hours < 2) {
    return [ONLY_SELECTED_SUBS_CHOICE];
  }

  return [
    ...NOTIFY_CHOICES.slice(0, -1).filter((choice) => {
      const notifyTime = now.plus({ hours: choice });
      return notifyTime < reqDate;
    }),
    DEFAULT_NOTIFY_CHOICE,
    ONLY_SELECTED_SUBS_CHOICE,
  ];
};

export const useTimeToAccept = (startDateTime: DateTime, now: DateTime) => {
  // Default to "selected subs only" if the start time is less than 2 hours away; otherwise, use the default.
  const initialTimeToAccept =
    startDateTime.diff(now, "hours").hours < 2 ? ONLY_SELECTED_SUBS_CHOICE : DEFAULT_NOTIFY_CHOICE;
  const [timeToAccept, setTimeToAccept] = useState<number | string>(initialTimeToAccept);
  const timeToAcceptChoices = getTimeToAcceptChoices(startDateTime, now);

  useEffect(() => {
    if (!timeToAcceptChoices.includes(timeToAccept)) {
      setTimeToAccept(initialTimeToAccept);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeToAccept, timeToAcceptChoices]);

  return {
    timeToAccept,
    setTimeToAccept,
    timeToAcceptChoices,
  };
};
